import React from 'react'
import { Link } from 'react-router-dom'

const Success = () => {
    return (
        <div className="flex flex-col justify-center items-center my-20">
            <div className="bg-white max-w-[95%] rounded-xl w-fit flex flex-col gap-4 justify-center items-center py-6 md:py-10 px-4 md:px-10">
                <div className="w-32 md:w-56">
                    <img src="../../Assets/Accounts/success.png" alt="" />
                </div>
                <p className='font-pop text-gray-400 text-center max-w-sm'>Your money has been successfully sent to your account</p>
                <button className="my-4 w-full bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-lg md:text-xl py-1 md:py-3 px-4 border border-black-500 hover:border-green-500 rounded-full  text-white animate__animated animate__backInUp ">
                    <Link to={'/user-dashboard'}>
                        Back To Dashboard
                    </Link>
                </button>
            </div>
        </div>
    )
}

export default Success